/* =============================================================================
   ATTENTION — fichier for.me, pas un fichier natif Pitch.
   Le fichier Pitch d'origine a ete renomme en : pitch-product-card.js
   Si tu mets un jour Pitch a jour, la mise a jour reinstallera son propre
   product-card.js et ECRASERA ce fichier. Sauvegarde-le avant toute mise a jour.
   ============================================================================= */

/* ==========================================================================
   product-card-hover.js
   --------------------------------------------------------------------------
   1) Badge de réduction (-X%) à côté du prix barré.
   2) SURVOL 2e IMAGE (couvre toute la carte via le calque CSS
      .product-card__content::before) :
        - survol de l'image  -> 2e image de la variante SÉLECTIONNÉE
        - survol d'une pastille -> 2e image de CETTE couleur
      Les 2e images sont récupérées via /products/{handle}.js (par leur alt =
      nom de la variante). On règle la variable CSS --hover-image ; le calque
      s'affiche en fondu au survol (géré par le CSS). Images brutes, HD.

   NOTE : toute la logique de "fond de couleur" (halo --variant-color) et de
   remplissage du bas de carte (--card-bottom-strip) a été SUPPRIMÉE — plus
   aucune teinte variante/produit n'est calculée ni posée.

   La variante sélectionnée est traquée au clic (event change) — fiable, car
   sur ces cartes le :checked natif reste false et le slideshow ne met pas à
   jour les attributs hidden.
   ========================================================================== */

(function () {

  var productCache = {}; // url produit -> Promise(json)

  /* Filtre SVG "verre liquide" : turbulence + displacement pour déformer
     (réfracter) le fond derrière le panneau de verre. Référencé par le CSS :
     backdrop-filter: ... url("#glass-distort"). Injecté une seule fois. */
  function injectGlassFilter() {
    if (document.getElementById('glass-distort')) return;
    var host = document.body || document.documentElement;
    if (!host) return;
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
        '<filter id="glass-distort" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.009 0.014" numOctaves="2" seed="7" result="noise"/>' +
          '<feGaussianBlur in="noise" stdDeviation="1.2" result="softNoise"/>' +
          '<feDisplacementMap in="SourceGraphic" in2="softNoise" scale="20" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter>' +
      '</svg>';
    host.appendChild(wrap);
  }
  if (document.readyState !== 'loading') injectGlassFilter();
  else document.addEventListener('DOMContentLoaded', injectGlassFilter);

  /* ------------------------------------------------------------ badge -X%  */

  function parseMoney(txt) {
    if (!txt) return 0;
    var s = txt.replace(/[^\d.,]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    return parseFloat(s) || 0;
  }

  function updateDiscountBadge(card) {
    var content = card.querySelector('.product-card__content') || card;
    var existing = card.querySelector('.price-discount-badge');
    var container = card.querySelector('[ref="priceContainer"]');
    var compareEl = container && container.querySelector('.compare-at-price');
    var priceEl = container && container.querySelector('.price');
    if (!compareEl || !priceEl) { if (existing) existing.remove(); return; }
    var comp = parseMoney(compareEl.textContent);
    var cur = parseMoney(priceEl.textContent);
    if (!comp || !cur || comp <= cur) { if (existing) existing.remove(); return; }
    var pct = Math.round((1 - cur / comp) * 100);
    var badge = existing || document.createElement('span');
    badge.className = 'price-discount-badge';
    badge.textContent = '-' + pct + '%';
    if (badge.parentElement !== content) content.appendChild(badge);
  }

  /* ------------------------------------------------------------ helpers    */

  function sizedUrl(src, width) {
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function nameOfInput(input) {
    return input ? (input.getAttribute('aria-label') || input.value || '').trim() : '';
  }

  function firstSwatchInput(card) {
    return card.querySelector('.variant-option__swatch input[data-option-media-id]') ||
           card.querySelector('.variant-option__swatch input');
  }

  /* variante sélectionnée : dernier clic mémorisé, sinon coché, sinon 1re */
  function selectedName(card) {
    if (card.__selectedName) return card.__selectedName;
    var chk = card.querySelector('.variant-option__swatch input:checked');
    if (chk) return nameOfInput(chk);
    return nameOfInput(firstSwatchInput(card));
  }

  /* Tous les noms de variantes présents sur CETTE carte, sans doublon.
     Le rapprochement « texte alternatif <-> variante » a besoin de la liste
     complète : c'est en comparant les noms entre eux qu'il sait quels mots
     distinguent une variante d'une autre (voir fm-alt-match.js). */
  function variantNamesOfCard(card) {
    if (card.__vnames && card.__vnames.length) return card.__vnames;
    var vu = {}, out = [];
    card.querySelectorAll('.variant-option__swatch input').forEach(function (i) {
      var n = nameOfInput(i);
      var k = n.toLowerCase();
      if (n && !vu[k]) { vu[k] = 1; out.push(n); }
    });
    card.__vnames = out;
    return out;
  }

  /* Clé de rangement commune au stockage et à la lecture. Sans fm-alt-match.js
     on retombe exactement sur l'ancienne clé (alt brut en minuscules), donc
     sur l'ancien comportement. */
  function cleVariante(s) {
    return window.FMAlt ? window.FMAlt.normalise(s) : (s || '').trim().toLowerCase();
  }

  /* --------------------------------------------------- 2e images (JSON)    */

  function fetchSeconds(card) {
    if (card.__seconds || card.__secondsPending) return;
    var a = card.querySelector('a[href*="/products/"]');
    var purl = a && a.getAttribute('href').split('?')[0].split('#')[0];
    if (!purl) { card.__seconds = {}; return; }
    card.__secondsPending = true;
    if (!productCache[purl]) {
      productCache[purl] = fetch(purl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    productCache[purl].then(function (p) {
      var packs = {};
      card.querySelectorAll('.variant-option__swatch input[data-option-media-id]').forEach(function (i) {
        var id = i.getAttribute('data-option-media-id'); if (id) packs[id] = 1;
      });
      /* La table est rangée PAR VARIANTE, plus par texte alternatif : chaque
         image est rapprochée d'une variante au moment de la construction, et
         la lecture au survol redevient une simple recherche par clé.
         C'est ici que « Nude » cesse d'être exigé à l'identique pour
         « 01 | Nude » — fm-alt-match.js s'en charge. */
      var noms = variantNamesOfCard(card);
      var map = {};
      if (p && p.media) p.media.forEach(function (m) {
        if (m.media_type && m.media_type !== 'image') return;
        var alt = (m.alt || '').trim();
        if (!alt || packs[m.id]) return;            // sauter les packshots des pastilles
        var v = window.FMAlt ? window.FMAlt.match(alt, noms) : alt;
        if (!v) return;                             // alt neutre : image commune
        var cle = cleVariante(v);
        if (map[cle]) return;                       // on garde la 1re image de chaque variante
        map[cle] = sizedUrl(m.src, 1600);
      });
      card.__seconds = map;
      Object.keys(map).forEach(function (k) { var im = new Image(); im.src = map[k]; }); // préchargement HD
    });
  }

  function secondUrl(card, name) {
    return (name && card.__seconds) ? (card.__seconds[cleVariante(name)] || null) : null;
  }

  /* --------------------------------------------------- survol 2e image     */

  /* règle --hover-image selon la zone survolée (le calque CSS fait le reste).
     Priorité : 2e image de la variante (par alt) -> sinon la 2e image du
     slideshow (repli, pour que TOUTES les cartes aient un survol, même les
     produits sans pastille). */
  function applyHover(card, name) {
    if (card.__hoverName === name) return;
    card.__hoverName = name;
    var url = secondUrl(card, name) || card.__secondSlideUrl || null;
    card.style.setProperty('--hover-image', url ? 'url("' + url + '")' : 'none');
    /* Drapeau lu par le CSS pour EFFACER la 1re image pendant le survol.
       Indispensable quand la 2e image est un PNG/WEBP à fond transparent :
       sans ça les deux photos se superposent et on voit la 1re à travers.
       Posé UNIQUEMENT s'il y a vraiment une 2e image — sinon la carte se
       viderait au survol des produits qui n'en ont pas. */
    if (url) card.setAttribute('data-fm-hover-image', '');
    else card.removeAttribute('data-fm-hover-image');
  }

  /* NB : pointerover/pointerout (qui remontent) et NON pointerenter/leave :
     sur ce thème, pointerenter en capture sur document ne se déclenche pas. */
  /* Vrai uniquement sur un appareil à souris. Un doigt émet lui aussi des
     pointerover : sans ce test, le survol se déclencherait à l'appui sur
     mobile. On teste AUSSI e.pointerType, parce qu'une tablette avec clavier
     et un écran tactile répond "oui" à la media query tout en étant touchée
     au doigt. */
  var PEUT_SURVOLER = false;
  try {
    PEUT_SURVOLER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  } catch (e) {}

  function overHandler(e) {
    if (!PEUT_SURVOLER || e.pointerType === 'touch') return;
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-card');
    if (!card) return;
    var label = t.closest('.variant-option__button-label, .variant-option__swatch label');
    if (label) {
      applyHover(card, nameOfInput(label.querySelector('input'))); // 2e image de CETTE pastille
    } else if (t.closest('.card-gallery')) {
      applyHover(card, selectedName(card)); // 2e image de la variante sélectionnée
    }
  }

  function outHandler(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-card');
    if (!card) return;
    if (card.contains(e.relatedTarget)) return; // encore dans la carte
    card.__hoverName = null; // reset (le calque se cache via le CSS)
    card.removeAttribute('data-fm-hover-image');
  }

  document.addEventListener('pointerover', overHandler, true);
  document.addEventListener('pointerout', outHandler, true);

  /* traçage de la variante sélectionnée au clic (capture : non bloqué par le
     stopPropagation du thème). */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (inp && inp.closest && inp.closest('.variant-option__swatch')) {
      var card = inp.closest('product-card');
      if (card) card.__selectedName = nameOfInput(inp);
    }
  }, true);

  /* Neutralise l'aperçu natif du thème (sinon le slideshow saute à l'image
     suivante sous notre calque au survol = effet glitch/zoom). On retire les
     attributs déclaratifs que le thème lit pour previewImage/previewVariant. */
  function stripThemeHover(card) {
    var g = card.querySelector('.card-gallery');
    if (g) { g.removeAttribute('on:pointerenter'); g.removeAttribute('on:pointerleave'); }
    card.querySelectorAll('.variant-option__button-label, .variant-option__swatch label').forEach(function (l) {
      l.removeAttribute('on:pointerenter'); l.removeAttribute('on:pointerleave');
    });
  }

  /* ------------------------------------------------------------ init       */

  function initCard(card) {
    stripThemeHover(card); // à chaque passage (re-render inclus)
    if (card.__init) return;
    card.__init = true;

    if (!card.__selectedName) card.__selectedName = nameOfInput(firstSwatchInput(card)); // défaut = 1re couleur

    // repli universel : 2e image du slideshow (pour les produits sans pastille)
    var slideImgs = card.querySelectorAll('slideshow-slide .product-media__image');
    if (slideImgs[1]) {
      card.__secondSlideUrl = sizedUrl(slideImgs[1].getAttribute('src') || slideImgs[1].currentSrc || '', 1600);
    }

    updateDiscountBadge(card);
    fetchSeconds(card);

    card.addEventListener('change', function () {
      setTimeout(function () { updateDiscountBadge(card); }, 80);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('product-card').forEach(initCard);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var n = added[k];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('product-card')) initCard(n);
        if (n.querySelectorAll) initAll(n);
        // re-render interne (clic variante) : ré-neutraliser l'aperçu natif
        var host = n.closest && n.closest('product-card');
        if (host) stripThemeHover(host);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* Masquer le nombre d'avis (l'app Inflate le force en inline, on le cache en JS) */
(function () {
  function hideCount() {
    document.querySelectorAll('.rating-count').forEach(function (p) {
      p.style.setProperty('display', 'none', 'important');
    });
  }
  hideCount();
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(hideCount, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();


(function () {
  var LIMIT = 4, mo = null;
  function apply() {
    if (mo) mo.disconnect();
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.product-card product-swatches').forEach(function (ps) {
      var ol = ps.querySelector('overflow-list');
      if (!ol) return;
      var card = ps.closest('.product-card');
      var items = ol.querySelectorAll('.variant-option__swatch');
      var chip = ps.querySelector('.fm-more-swatches');

      if (!mobile) { ol.removeAttribute('disabled'); if (chip) chip.remove(); return; }

      ol.setAttribute('disabled', 'true');
      var hidden = Math.max(0, items.length - LIMIT);
      if (hidden > 0) {
        if (!chip) {                                   // créé UNE fois, pas recréé au clic
          var link = card && (card.querySelector('[ref="productTitleLink"]') || card.querySelector('a[href*="/products/"]'));
          chip = document.createElement(link ? 'a' : 'span');
          chip.className = 'fm-more-swatches';
          if (link) chip.href = link.href;
          ps.appendChild(chip);                        // sur product-swatches (survit au re-render)
        }
        chip.textContent = '+' + hidden;
      } else if (chip) { chip.remove(); }
    });
    if (!mo) mo = new MutationObserver(function () { clearTimeout(window.__fmSw); window.__fmSw = setTimeout(apply, 60); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
})();

/* ==========================================================================
   LA BANDE FONCEE QUI CLIGNOTAIT SUR LES CARTES
   --------------------------------------------------------------------------
   Le degrade sombre du haut de carte est peint par le CONTENEUR, donc SOUS
   l'image. Tant que la photo n'est pas arrivee, rien ne le masque : la carte
   affiche une bande grise, qui disparait des que l'image parait. Mesure :
   rgba(0,0,0,0.20) sur du blanc = rgb(204,204,204), exactement le gris vu.

   Ce bloc pose data-fm-image-prete sur le conteneur quand l'image est la, et
   product-card.css ne dessine le degrade qu'a partir de cet attribut.

   LE CAS DU CACHE EST LE PLUS IMPORTANT. Une image deja en cache est souvent
   COMPLETE avant meme que ce script ne tourne : son evenement `load` est
   DEJA PASSE et ne se redeclenchera jamais. S'abonner sans verifier
   `complete` laisserait ces cartes sans degrade pour toujours — on aurait
   remplace un clignotement par une disparition. D'ou le test d'abord,
   l'abonnement ensuite.

   decoding="async" + une image en cache : `complete` est vrai mais la
   premiere peinture peut suivre d'une image. `decode()` attend ce moment
   exact quand le navigateur le propose ; sinon on pose l'attribut tout de
   suite, ce qui etait le comportement d'avant.

   L'OBSERVATEUR sert aux cartes qui arrivent plus tard : pagination, filtres
   de collection, ajout rapide, resultats de recherche. Il ne refait rien sur
   les cartes deja marquees.
   ========================================================================== */
(function () {
  'use strict';

  var PRET = 'data-fm-image-prete';

  function marquer(carte) {
    if (carte.hasAttribute(PRET)) return;
    carte.setAttribute(PRET, '');
  }

  function suivre(carte) {
    if (carte.hasAttribute(PRET) || carte.__fmSuivie) return;
    var img = carte.querySelector('img');
    if (!img) return;                                /* pas d'image : rien a attendre */
    carte.__fmSuivie = true;

    if (img.complete && img.naturalWidth > 0) {
      if (img.decode) {
        img.decode().then(function () { marquer(carte); },
                          function () { marquer(carte); });
      } else {
        marquer(carte);
      }
      return;
    }

    img.addEventListener('load', function () { marquer(carte); }, { once: true });
    /* Une image cassee ne chargera jamais : on marque quand meme, sinon la
       carte resterait sans son degrade indefiniment. */
    img.addEventListener('error', function () { marquer(carte); }, { once: true });
  }

  function passer() {
    var cartes = document.querySelectorAll('.product-card__content');
    for (var i = 0; i < cartes.length; i++) suivre(cartes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', passer);
  } else {
    passer();
  }
  window.addEventListener('load', passer);

  var attendu = false;
  new MutationObserver(function () {
    if (attendu) return;
    attendu = true;
    window.setTimeout(function () { attendu = false; passer(); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();